import { Record, Set } from 'immutable';
import { EventSearchFilter } from './event-filter';

const EventSearchParametersRecord = Record({
  maxEvents: 0,
  searchText: Set([]),
  filters: Set([])
});

export class EventSearchParameters extends EventSearchParametersRecord {
  maxEvents: number;
  searchText: Set<string>;
  filters: Set<EventSearchFilter>;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/event-search-params.ts